// extracted by mini-css-extract-plugin
module.exports = {"logo":"AnimatedLogo_logo__KZI_S","maskElem":"AnimatedLogo_maskElem__VmsEU","mask":"AnimatedLogo_mask__Q8zqY"};